import type { ReactNode } from 'react';

// Lucide-style inline icons, 2px stroke, round caps, as the handoff specifies.
// Decorative everywhere they are used: the text beside each carries the meaning.
//
// Only glyphs the shared set (components/icons) lacks, or draws differently,
// live here. The info "i" and warning triangle come from the shared set
// (InfoIcon, AlertTriangleIcon — identical paths and 2px stroke), sized by the
// `ga-ico-*` classes. Kept local on purpose: CheckIcon (the shared one is a
// 2.5px stroke, the handoff's is 2px) and SearchIcon (the shared one is a
// smaller lens on a different path).
export function Icon({ size = 14, children }: { size?: number; children: ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export const GlobeIcon = () => (
  <Icon size={12}>
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </Icon>
);

export const ShieldIcon = () => (
  <Icon size={12}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </Icon>
);

export const LayersIcon = () => (
  <Icon size={26}>
    <polygon points="12 2 2 7 12 12 22 7 12 2" />
    <polyline points="2 17 12 22 22 17" />
    <polyline points="2 12 12 17 22 12" />
  </Icon>
);

export const CheckIcon = () => (
  <Icon>
    <polyline points="20 6 9 17 4 12" />
  </Icon>
);

export const SearchIcon = () => (
  <Icon>
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </Icon>
);
